import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { animate } from "motion";

/**
 * Motion-backed fade helper that works with React 16 (no motion/react dependency).
 * Opacity-only by default to avoid clunky movement/scale effects.
 */
export default function MotionFade({
  in: inProp,
  durationMs = 250,
  children,
  style,
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;

    const controls = animate(
      ref.current,
      { opacity: inProp ? 1 : 0 },
      { duration: Math.max(0, durationMs) / 1000, easing: "ease-in-out" }
    );

    return () => {
      try {
        controls?.stop?.();
      } catch {}
    };
  }, [inProp, durationMs]);

  return (
    <span
      ref={ref}
      style={{
        display: "inline-block",
        opacity: inProp ? 1 : 0,
        willChange: "opacity",
        ...style,
      }}
    >
      {children}
    </span>
  );
}

MotionFade.propTypes = {
  in: PropTypes.bool.isRequired,
  durationMs: PropTypes.number,
  children: PropTypes.node,
  style: PropTypes.object,
};

